import {
  PopoverContentProps,
  PopoverTriggerProps,
} from '@radix-ui/react-popover'
import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

import { Chip } from '../chip'
import { Icon } from '../icon'
import * as Popover from '../popover'

export const { Root } = Popover

type TriggerProps = PopoverTriggerProps & {
  selected?: boolean
}

export const Trigger = ({ selected, children, ...restProps }: TriggerProps) => {
  return (
    <Popover.Trigger asChild {...restProps}>
      <Chip
        variant="outline"
        size="medium"
        shape="pill"
        selected={selected}
        className="[&[data-state=open]_svg]:rotate-180"
        endIcon={
          <Icon
            name="arrow-bottom"
            className={cn('transition-transform duration-200')}
          />
        }
      >
        {children}
      </Chip>
    </Popover.Trigger>
  )
}

type ContentProps = PopoverContentProps & ComponentProps<typeof Popover.Content>

export const Content = ({
  className,
  children,
  ...restProps
}: ContentProps) => {
  return (
    <Popover.Content
      className={cn(
        'flex flex-col gap-4 rounded-xl p-5 shadow-[0px_0px_7px_0px_rgba(0,0,0,0.2)] drop-shadow-none',
        className,
      )}
      align="start"
      side="bottom"
      sideOffset={8}
      closeButton={false}
      arrow={false}
      {...restProps}
    >
      {children}
    </Popover.Content>
  )
}
